const allowedProductTypes = [
  "Contact-lenses",
  "Frames",
  "Solutions",
  "Sunglasses",
  "Ready-readers",
  "Accessories"
];
const isAllowedProductName = (productType) => allowedProductTypes.includes(productType);
const createProductTypeName = (str = "") => {
  const name = (str.charAt(0).toUpperCase() + str.slice(1).toLowerCase()).replace("_", "-");
  if (isAllowedProductName(name)) {
    return name;
  }
  return void 0;
};
export {
  createProductTypeName
};
//# sourceMappingURL=create-product-type-name.js.map
